import { render, staticRenderFns } from "./sourceCodePreview.vue?vue&type=template&id=38db0149&scoped=true&"
import script from "./sourceCodePreview.vue?vue&type=script&lang=ts&"
export * from "./sourceCodePreview.vue?vue&type=script&lang=ts&"
import style0 from "./sourceCodePreview.vue?vue&type=style&index=0&id=38db0149&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db0149",
  null
  
)

export default component.exports